// extracted by mini-css-extract-plugin
export default {"drawer":"styles_drawer__zEwaV","closeCouponDrawerContainer":"styles_closeCouponDrawerContainer__0dqFV","closeCouponDrawer":"styles_closeCouponDrawer__J13JK"};